<template>
  <v-card elevation="0" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'" class="pl-3 edit-news">
    <v-container class="custom-container responsive-height">
      <v-row>
        <v-col cols="12">
          <v-card-title class="pb-0">
            You can update your Logo and Favicon from here
          </v-card-title>
        </v-col>
        <v-col cols="12" class="mb-2">
           <v-col cols="12">
            <v-card class="deposit-form px-5" color="transparent">
              <v-row>
                <v-col cols="12" sm="12" lg="6" md="6">
                  <fieldset class="custom-upload-file">
                    <legend>Light Logo</legend>
                    <v-file-input v-model="formlogo.logo_url" label="Choose file (Max Size 2MB)" single-line solo
                      prepend-icon="mdi-file-image" hide-details class="custom-select"
                      @change="onFileChange(1)">
                    </v-file-input>
                    <v-img v-if="generalInfos?.logo_url" :src="generalInfos?.logo_url" height="40"></v-img>
                    <v-img  v-else src="/loader.gif" height="40"></v-img>
                  </fieldset>
                </v-col>

                <v-col cols="12" sm="12" lg="6" md="6">
                  <fieldset class="custom-upload-file">
                    <legend>Dark Logo</legend>
                    <v-file-input v-model="formlogo.logo_url_dark" label="Choose file (Max Size 2MB)" single-line solo
                      prepend-icon="mdi-file-image" hide-details class="custom-select"
                      @change="onFileChange(2)">
                    </v-file-input>
                    <v-img v-if="generalInfos?.logo_url_dark" :src="generalInfos?.logo_url_dark" height="40"></v-img>
                    <v-img  v-else src="/loader.gif" height="40"></v-img>
                  </fieldset>
                </v-col>

                <v-col cols="12" sm="12" lg="6" md="6">
                  <fieldset class="custom-upload-file">
                    <legend>Favicon</legend>
                    <v-file-input v-model="formlogo.favicon_url" label="Choose file (Max Size 2MB)" single-line solo
                      prepend-icon="mdi-file-image" class="custom-select" @change="onFileChange(3)">
                    </v-file-input>
                    <v-img v-if="generalInfos?.favicon_url" :src="generalInfos?.favicon_url" height="40"></v-img>
                    <v-img  v-else src="/loader.gif" height="40"></v-img>
                  </fieldset>
                </v-col>

              </v-row>
            </v-card>
        </v-col>

        <v-col cols="12" class="ml-5" v-if="$canRoute('general-info') === 1">
          <v-btn large tile elevation="0" class="text-capitalize btn-account" color="#00E396" @click="submitFormlogo" :loading="loadingLogo"
          :disabled="loadingLogo">
            Update
          </v-btn>
        </v-col>
        </v-col>

        <v-col cols="12">
          <v-card-title class="pb-0">
            You can update your general information from here
          </v-card-title>
        </v-col>
        <v-col cols="12">
          <v-card class="deposit-form px-5" color="transparent">
            <v-row>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Company Name</legend>
                  <v-text-field v-model="form.company_name" label="Forex CRM" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Risk Warning Title</legend>
                  <v-text-field v-model="form.risk_warning_title" label="High Risk Investment Warning" single-line solo
                    hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Company URL</legend>
                  <v-text-field v-model="form.company_url" label="https://forexcrm.ca" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col> 

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Company Short Description</legend>
                  <v-text-field v-model="form.company_short_description" label="Lorem Ipsum..." single-line solo
                    hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Legal Information Title</legend>
                  <v-text-field v-model="form.legal_information_title" label="Legal Information" single-line solo
                    hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Copyright Text</legend>
                  <v-text-field v-model="form.copyright_text" label="© 2017 Forex CRM. All Rights Reserved." single-line
                    solo hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>IPStack API Key</legend>
                  <v-text-field v-model="form.ipstack_api_key" label="2b11983a0a8318e529cc10876638e54c" single-line solo
                    hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Client Portal URL</legend>
                  <v-text-field v-model="form.client_portal_url" label="https://clientv1.forexcrm.ca" single-line solo
                    hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Open Live Account Page Header</legend>
                  <v-text-field v-model="form.open_live_account_page_header" label="40 Years Of Excellence" single-line
                    solo hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Partner Portal URL</legend>
                  <v-text-field v-model="form.partner_portal_url" label="https://partnerv1.forexcrm.ca" single-line solo
                    hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Live Chat Link</legend>
                  <v-text-field v-model="form.live_chat_link" label="#" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Admin Portal URL</legend>
                  <v-text-field v-model="form.admin_portal_url" label="https://adminv1.forexcrm.ca" single-line solo
                    hide-details class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Phone</legend>
                  <v-text-field v-model="form.phone" label="+16146828846800" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Facebook Link</legend>
                  <v-text-field v-model="form.facebook_link" label="Paste Here" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Address</legend>
                  <v-text-field v-model="form.address" label="Write Here" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Twitter Link</legend>
                  <v-text-field v-model="form.twitter_link" label="Paste Here" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Youtube Link</legend>
                  <v-text-field v-model="form.youtube_link" label="Paste Here" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset>
                  <legend>Linked in Link</legend>
                  <v-text-field v-model="form.linked_in_link" label="Paste Here" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>

               <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset class="custom-textarea">
                  <legend>Risk Warning Text</legend>
                  <v-textarea v-model="form.risk_warning_text" single-line auto-grow solo hide-details
                    class="custom-select"></v-textarea>
                </fieldset>
              </v-col>
              <v-col cols="12" xl="6" lg="6" md="6">
                <fieldset class="custom-textarea">
                  <legend>Legal Information Text</legend>
                  <v-textarea v-model="form.legal_information_text" single-line auto-grow solo hide-details class="custom-select"></v-textarea>
                </fieldset>
              </v-col>

            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" class="ml-5" v-if="$canRoute('general-info') === 1">
          <v-btn large tile elevation="0" class="text-capitalize btn-account" color="#00E396" @click="submitForm" :loading="loadingGeneral"
            :disabled="loadingGeneral">
            Update
          </v-btn>
        </v-col>

      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { GENERALINFO__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      origin: '',
      form: {
        company_name: "",
        company_url: "",
        company_short_description: "",
        ipstack_api_key: "",
        client_portal_url: "",
        partner_portal_url: "",
        admin_portal_url: "",
        facebook_link: "",
        twitter_link: "",
        youtube_link: "",
        linked_in_link: "",
        risk_warning_title: "",
        risk_warning_text: "",
        legal_information_title: "",
        legal_information_text: "",
        copyright_text: "",
        open_live_account_page_header: "",
        live_chat_link: "",
        phone: "",
        address: "",
      },
      formlogo: {
        logo_url: "",
        logo_url_dark: "",
        favicon_url: "",
      },
      loadingLogo: false,
      loadingGeneral: false,
    };
  },

  computed: {
    ...mapState("generalinfo", ["generalInfos"]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("generalinfo", [
      GENERALINFO__ACTIONS.GENERALINFO,
      GENERALINFO__ACTIONS.UPDATEGENERALINFO,
      GENERALINFO__ACTIONS.UPDATEGENERALINFOLOGO,
    ]),
    ...mapMutations("generalinfo", ["updateGeneralInfo"]),
    onFileChange(type) {
      let file;
      switch (type) {
        case 1:
          file = this.formlogo.logo_url;
          if (file) {
            const tempUrl = URL.createObjectURL(file);
            this.updateGeneralInfo({ key: "logo_url", value: tempUrl });
          }
          break;
        case 2:
          file = this.formlogo.logo_url_dark;
          if (file) {
            const tempUrl = URL.createObjectURL(file);
            this.updateGeneralInfo({ key: "logo_url_dark", value: tempUrl });
          }
          break;
        case 3:
          file = this.formlogo.favicon_url;
          if (file) {
            const tempUrl = URL.createObjectURL(file);
            this.updateGeneralInfo({ key: "favicon_url", value: tempUrl });
          }
          break;
        default:
          break;
      }
    },

    async submitForm() {
      this.loadingGeneral = true;
      try {
        await this[GENERALINFO__ACTIONS.UPDATEGENERALINFO](this.form);
        console.log("Form submitted successfully");
      } catch (error) {
        console.error("Error submitting form:", error);
      }finally {
      this.loadingGeneral = false; 
      }
    },

    async submitFormlogo() {
      this.loadingLogo = true;
      try {
        await this[GENERALINFO__ACTIONS.UPDATEGENERALINFOLOGO](this.formlogo);
        console.log("Form submitted successfully");
      } catch (error) {
        console.error("Error submitting form:", error);
      }finally {
      this.loadingLogo = false; 
      }
    },

    populateForm() {
      if (this.generalInfos) {
        Object.keys(this.form).forEach(key => {
          if (key in this.generalInfos) {
            this.form[key] = this.generalInfos[key];
          }
        });
        console.log('Populated form:', this.form);
      } else {
        console.warn('generalInfos is undefined or null');
      }
    }
  },

  async created() {
    await this[GENERALINFO__ACTIONS.GENERALINFO]();
    this.populateForm();
    this.origin = window.location.origin
  },
};
</script>
